import type { FC, ReactNode } from 'react';
import { Box, Typography } from '@material-ui/core';
import Loading from 'src/components/global/Loading';

type DashboardWidgetProps = {
  title: string;
  loading?: boolean;
  hasData?: boolean;
  emptyMessage?: string;
  children: ReactNode;
};

export const DashboardWidget: FC<DashboardWidgetProps> = ({
  title,
  loading = false,
  hasData = true,
  emptyMessage = 'Sin informacion disponible.',
  children,
}) => (
  <Box
    style={{
      background: '#f5f5f5',
      borderRadius: 8,
      padding: '12px 16px',
      width: '100%',
      height: 'auto',
      minHeight: '380px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Typography
      component="h2"
      style={{
        textAlign: 'center',
        margin: '0 0 18px',
        fontSize: 18,
        fontWeight: 700,
        color: '#4a4a4a',
        letterSpacing: 1,
      }}
    >
      {title}
    </Typography>

    {loading ? (
      <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
        <Loading />
      </Box>
    ) : null}

    {!loading && !hasData ? (
      <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
        <Typography style={{ color: '#6b6b6b', fontSize: 14 }}>{emptyMessage}</Typography>
      </Box>
    ) : null}

    {!loading && hasData ? children : null}
  </Box>
);
